import { FunctionComponent, useMemo } from "react";
import { Page } from "../Page";
import { 
    Text,
    Heading,
    Card,
    Flex
 } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import { enGB } from "date-fns/locale";

export const SubmissionPage: FunctionComponent = () => {

    const location = useLocation();
    const { surveyId } = location.state;


    const dateTime = useMemo(() => {
        // P - Long localized date (04/29/1453) ; pp - Long localized time (12:00:00 AM)
        return format(new Date(), 'P pp', {
            locale: enGB
        })
    }, []);

    return (
        <Page
            title={`Online Assessment Tool`} 
            footer={(<></>)}
        >
            <Flex justifyContent="center">
                <Card padding="5">
                    <Flex gap="3">
                        <FaCheckCircle color="green" />
                        <Heading lineHeight="1rem" fontWeight="bold">Survey Submitted</Heading>
                    </Flex>
                    <Text mb="3">Thank you, your survey has been submitted with the following details:</Text>
                    <Text><b>Survey ID: </b>{surveyId}</Text>
                    <Text><b>Submission Time: </b>{dateTime}</Text>
                </Card>
            </Flex>
        </Page>
    )
}
